import { Text } from '../text'
import s from './style.module.scss'

interface IFormLabel {
  label?: string
  color?: string
  required?: boolean
}

function FormLabel({ label, color, required }: IFormLabel) {
  return label ? (
    <Text className={s.label} color={color} required={required}>
      {label}
    </Text>
  ) : (
    <span />
  )
}

export default FormLabel
